import { render, staticRenderFns } from "./MedidaFormulario.vue?vue&type=template&id=0b78b73d"
import script from "./MedidaFormulario.vue?vue&type=script&lang=js"
export * from "./MedidaFormulario.vue?vue&type=script&lang=js"
import style0 from "./MedidaFormulario.vue?vue&type=style&index=0&id=0b78b73d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports